import { ReactElement, useState } from 'react';
import { Box, Card, Typography } from '@mui/material';
import { ButtonWithDialog, PodsTable } from '@localstack/ui';
import { CloudPod } from '@localstack/types';

import { CloudPodsService, useApiGetter, useRoutes, useInjectPodState, useAwsGetter } from '@localstack/services';

import { AppRoute } from '~/config';
import { ContainedCustomerLayout } from '~/layouts';

export const CloudPodsPublic = (): ReactElement => {
  const { goto } = useRoutes();
  const [selectedPods, setSelectedPods] = useState<string[]>([]);
  const { data: health } = useAwsGetter('LocalStack', 'getHealth', [], { silentErrors: true });

  const isLocalStackRunning = !!Object.keys(health || {}).length;
  const { data: allPods, isLoading: isPodLoading } = useApiGetter(CloudPodsService, 'listPublicCloudPods', [], {
    defaultValue: [],
  });

  const { inject, isLoading: isPodInjecting } = useInjectPodState();

  const pods = (allPods ?? []).filter((pod) => !pod.pod_name.match(/^ci[:_].+/));
  const isLoading = isPodLoading || isPodInjecting;
  const selectedPod = pods?.find((findPod: CloudPod) => findPod.id === selectedPods.at(0));

  return (
    <ContainedCustomerLayout
      title="Public Cloud Pods"
      dropdownActions={
        <ButtonWithDialog
          componentType="MenuItem"
          color="primary"
          disabled={!isLocalStackRunning || !selectedPod}
          onClick={() => selectedPod && inject(selectedPod)}
          dialogTitle={`Load pod ${selectedPod?.pod_name}?`}
          dialogContent="The state of this cloud pod will be loaded into your locally running instance."
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="inherit">Load</Typography>
            {!isLocalStackRunning && (
              <Typography lineHeight="inherit" fontSize={12}>
                Stack is not running
              </Typography>
            )}
          </Box>
        </ButtonWithDialog>
      }
    >
      <Card>
        <PodsTable
          pods={(pods as CloudPod[]) || []}
          loading={isLoading}
          onViewPod={(name) => goto(AppRoute.POD, { name })}
          onSelect={setSelectedPods}
          hideUserId
        />
      </Card>
    </ContainedCustomerLayout>
  );
};
